/// <amd-module name="Reporting/Visuals/VisualMessages/AxFaultInMessage" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Size, VisualMessageBase } from "./VisualMessageBase";

export interface AxFaultInProps {
    visualTitle: string;
    size: Size;
}

/** Used for Rendering "Analytics Fault-in" Experiences for visuals. */
export class AxFaultInMessage extends VssComponent<AxFaultInProps, {}> {
    public render(): JSX.Element {
        return (
            <VisualMessageBase
                visualTitle={this.props.visualTitle}
                messageContent={Resources.AxFaultIn_Message}
                size={this.props.size}
                imagePath={this.getResource()}
                altText={Resources.AxFaultIn_AltText}
            />
        );
    }

    public getResource(cardId?: number): string {
        const location = `ms.vss-reporting/reporting-visuals-common/images/service-setup.png`;
        return location;
    }
}
